import { isEmpty } from 'lodash';

export function validateLocationPage(data = {}) {
    let errors = {};


    const isQuillEmpty = (val = "") => {
        const v = val.trim();
        return v === "" || v === "<p><br></p>" || v === "<br>" || v === "<p></p>";
    };

    // Basic Information Validation
    if (!data.stateName?.trim()) {
        errors.stateName = 'State is required';
    }

    if (!data.stateCode?.trim()) {
        errors.stateCode = 'State Code is required';
    }

    if (!data.city?.trim()) {
        errors.city = 'City is required';
    }

    // SEO Validation
    if (!data.metaTitle?.trim()) {
        errors.metaTitle = 'Meta Title is required';
    }

    if (!data.metaDescription?.trim()) {
        errors.metaDescription = 'Meta Description is required';
    }

    // // ==============================
    // // TOP SECTION
    // // ==============================
    if (!data.topSection?.pageTitle?.trim()) {
        errors.topSectionPageTitle = 'Heading is required';
    }

    if (!data.topSection?.subHeading?.trim()) {
        errors.topSectionSubHeading = 'Sub Heading is required';
    }
    if (isQuillEmpty(data.topSection?.topDescription?.trim())) {
        errors.topSectiontopDescription = 'content is required';
    }

    // // ==============================
    // // HERO SECTION
    // // ==============================
    if (!data.heroSection?.title || data.heroSection.title.trim() === "") {
        errors.heroTitle = "Title is required";
    }

    if (!data.heroSection?.banners || !Array.isArray(data.heroSection.banners)) {
        errors.heroBanners = "At least three banners in Hero section are required";
    } else {
        const banners = data.heroSection.banners;

        // Check minimum 3 banners
        if (banners.length < 3) {
            errors.heroBanners = "At least three banners in Hero section are required";
        }

        // Check if at least one banner is active
        const hasActiveBanner = banners.some((b) => b.status === "active");
        if (!hasActiveBanner) {
            errors.heroBannersActive = "At least one banner in Hero section must be active";
        }
    }
    if (isQuillEmpty(data.heroSection.heroSectionPara)) {
        errors.heroSectionPara = "Content is required";
    }

    // // ==============================
    // // CATEGORY SECTION
    // // ==============================
    if (!data.categorySection || !Array.isArray(data.categorySection) || data.categorySection.length === 0) {
        errors.categorySection = 'At least one category section is required';
    } else {
        data.categorySection.forEach((section, index) => {
            if (!section.categoryName?.trim()) {
                errors[`categorySection[${index}].categoryName`] = 'Category name is required';
            }
            if (!section.bentoGridHeading?.trim()) {
                errors[`categorySection[${index}].bentoGridHeading`] = 'Heading is required';
            }
            if (!section.bentoGridHeading1?.trim()) {
                errors[`categorySection[${index}].bentoGridHeading1`] = 'Heading is required';
            }
            if (!section.layoutType?.trim()) {
                errors[`categorySection[${index}].layoutType`] = 'Layout type is required';
            }
            // If defaultRedirectUrlEnable is true, defaultGridUrl must be non-empty
            if (section.defaultRedirectUrlEnable && !section.defaultGridUrl?.trim()) {
                errors[`categorySection[${index}].defaultGridUrl`] = 'Default grid URL is required if redirect is enabled';
            }


            // Only validate if categorySection and layoutType is not 'No Grid'
            if (data.categorySection && section?.layoutType !== 'No Grid') {
                // Desktop Banner validation
                if (!section.desktopBanner?.imageUrl?.trim()) {
                    errors[`categorySection[${index}].desktopBanner.imageUrl`] = 'Desktop banner image is required';
                }
                // Mobile Banner validation
                if (!section.mobileBanner?.imageUrl?.trim()) {
                    errors[`categorySection[${index}].mobileBanner.imageUrl`] = 'Mobile banner image is required';
                }

                // Desktop Grid validation
                if (!Array.isArray(section.desktopGrid) || section.desktopGrid.length === 0) {
                    errors[`categorySection[${index}].desktopGrid`] = 'At least one desktop grid item is required';
                }
                // Mobile Grid validation
                if (!Array.isArray(section.mobileGrid) || section.mobileGrid.length === 0) {
                    errors[`categorySection[${index}].mobileGrid`] = 'At least one mobile grid item is required';
                }
            }
        });
    }

    // // ==============================
    // // CUSTOMER REVIEWS
    // // ==============================
    if (!data.customerReviews || data.customerReviews.trim() === "") {
        errors.customerReviews = "Title is required";
    }

    // // ==============================
    // // DELIVERY SECTION
    // // ==============================
    if (!data.deliverySection?.sectionTitle?.trim()) {
        errors.deliverySectionTitle = "Title is required";
    }

    if (!data.deliverySection?.sectionPara?.trim()) {
        errors.deliverySectionPara = "Paragraph is required";
    }

    if (
        !Array.isArray(data.deliverySection?.subData) ||
        data.deliverySection.subData.length === 0
    ) {
        errors.deliverySectionSubData = "At least one item in delivery section required";
    } else {
        data.deliverySection.subData.forEach((item, index) => {
            // Image Validation
            if (!item.image?.trim()) {
                errors[`deliverySubData_${item.deliveryId || index}_image`] = "Icon is required";
            }

            // Heading Validation
            if (!item.heading?.trim()) {
                errors[`deliverySubData_${item.deliveryId || index}_heading`] =
                    "Heading is required";
            }

            // SubHeading Validation
            if (!item.subHeading?.trim()) {
                errors[`deliverySubData_${item.deliveryId || index}_subHeading`] =
                    "Sub-Heading is required";
            }

            // Paragraph Validation
            if (!item.paragraph?.trim()) {
                errors[`deliverySubData_${item.deliveryId || index}_paragraph`] =
                    "Paragraph is required";
            }
        });
    }


    if (isQuillEmpty(data.cityParagraph)) {
        errors.cityParagraph = "Content is required"
    }

    // // ==============================
    // // FAQ SECTION
    // // ==============================

    if (!data.faqSection?.title?.trim()) {
        errors.faqTitle = "Title is required";
    }

    if (!Array.isArray(data.faqSection?.subData) || data.faqSection.subData.length === 0) {
        errors.faqSectionSubData = "At least one item in FAQ section is required";
    } else {
        data.faqSection.subData.forEach((item) => {
            if (isQuillEmpty(item.question)) {
                errors[`faq_${item.faqId}_question`] = "Question is required";
            }
            if (isQuillEmpty(item.answer)) {
                errors[`faq_${item.faqId}_answer`] = "Answer is required";
            }
        });
    }


    // // ==============================
    // // BOTTOM SECTION
    // // ==============================

    if (isQuillEmpty(data.bottomSection?.description?.trim())) {
        errors.bottomSectionDescription = 'Content is required';
    }

    return {
        isValid: isEmpty(errors),
        errors
    };
}